import { render, staticRenderFns } from "./TablePhieuSuaChua.vue?vue&type=template&id=324eb3b4&scoped=true"
import script from "./TablePhieuSuaChua.vue?vue&type=script&lang=js"
export * from "./TablePhieuSuaChua.vue?vue&type=script&lang=js"
import style0 from "./TablePhieuSuaChua.vue?vue&type=style&index=0&id=324eb3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324eb3b4",
  null
  
)

export default component.exports